import { adminRequest } from '@/shared/request-configs/admin-request';
import { IWebhook } from '@/shared';

/**
 * Fetches Webhooks <br>
 * API Endppint - `/outbound-notifications-service/webhook/${clientId}` <br> via {@link adminRequest.get}
 * @param {number} clientId - id of the client
 */
export const get = async (clientId: number) => adminRequest.get(`/outbound-notifications-service/webhook/${clientId}`);

/**
 * Creates | Updates Webhook <br>
 * API Endpoints:
 * <Li>`/outbound-notifications-service/webhook/${payload.clientId}/${payload.id}` <br> via {@link adminRequest.put}</li>
 * <Li>`/outbound-notifications-service/webhook/${payload.clientId}` <br> via {@link adminRequest.post}</li>
 * @param {IWebhook} payload - webhook to update/create
 */
export const post = async (payload: IWebhook) => {
  if (payload.id) {
    return adminRequest.put(`/outbound-notifications-service/webhook/${payload.clientId}/${payload.id}`, payload);
  }
  return adminRequest.post(`/outbound-notifications-service/webhook/${payload.clientId}`, payload);
};

/**
 * Test Fetch of Webhook <br>
 * API Endpoint - `/outbound-notifications-service/test_webhook/${webhookId}` <br> via {@link adminRequest.get}
 * @param {string} webhookId - id of the webhook
 */
export const testGet = async (webhookId: string) => adminRequest.get(`/outbound-notifications-service/test_webhook/${webhookId}`);

export default {
  get,
  post,
  testGet,
};
